'use client';

import { DocsShell } from '@bomdisoft/components/docs';
import { getLanguageFromLocale } from '@bomdisoft/translations';
import { useParams } from 'next/navigation';
import { buildConsoleHome } from 'Clepit/shared/docs-content';
import { docsNav } from 'Clepit/shared/docs-nav-manifest';
import { docsThemeOverrides } from 'Clepit/shared/docs-theme';

const ConsoleHomePage = () => {
  const params = useParams();
  const langPrefix = typeof params.lang === 'string' ? params.lang : 'en';
  const language = getLanguageFromLocale(langPrefix);
  return <DocsShell content={buildConsoleHome(language)} lang={language} langPrefix={langPrefix} nav={docsNav} testId='docs-shell' themeOverrides={docsThemeOverrides} />;
};

export default ConsoleHomePage;
